@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.shipment-status-icon {
  width: 30px;
  height: 30px;
  position: relative;
  background: @shipment-status-icon--background-color;
  border-radius: 50%;

  &.big {
    height: 35px;
    width: 35px;
  }

  &.darker {
    background-color: @shipment-status-icon--darker--background-color;
  }

  &.show-icon {
    .icon {
      display: block;
    }
  }

  &.error {
    .icon {
      display: block;
      color: @shipment-status-icon--error--fill-color;
    }
  }

  &.processing {
    .icon {
      display: block;
      color: @shipment-status-icon--processing--fill-color;
      animation: spin 1350ms linear infinite;
    }
  }

  &.completed,
  &.shipped {
    background: @shipment-status-icon--shipped--background-color;
    .icon {
      display: block;
    }

    &.darker {
      background-color: @shipment-status-icon--shipped--background-color;
    }
  }

  &.clickable {
    cursor: pointer;
  }
}

.shipment-status-icon-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  place-content: center center;
}

.icon {
  color: @shipment-status-icon--fill-color;
  display: none;
}

.error-indicator {
  position: absolute;
  bottom: 0;
  right: 0;
  background: @shipment-status-icon--error--background-color;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid @shipment-status-icon--error--border-color;
}

.tooltip-content {
  max-width: 300px;
}

.wide-tooltip-content {
  width: 250px;
}
